import React, { useContext } from 'react';

import WidgetContext from '@totem/components/customDashboard/home/widgets/WidgetContext';
import TicketListContainer, {
  containerConfiguration,
} from '@totem/components/ticketing/listContainer/TicketListContainer';
import TicketsFavoritesTable from '@totem/components/ticketing/myTickets/favorites/favoritesTable';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';
import { TICKETS_ENDPOINT } from '@totem/utilities/endpoints';

const WidgetTicketFavorites = () => {
  const { onSetTitle, componentInstance } = useContext(WidgetContext);

  return (
    <InputContainer
      filterConfig={containerConfiguration}
      defaultSort={{
        field: 'createdAt',
        direction: 'descend',
      }}
      defaultFilters={[
        {
          field: 'status',
          values: ['OPEN', 'RESOLVED'],
        },
      ]}
      componentKey={`${componentInstance.componentInstanceId}`}
    >
      <TicketListContainer
        ticketEndPoint={`${TICKETS_ENDPOINT}/favorites`}
        onRecordTotalChanged={(recordCount: number) =>
          onSetTitle(<RecordCountBadge count={recordCount} />)
        }
      >
        <TicketsFavoritesTable />
      </TicketListContainer>
    </InputContainer>
  );
};

export default WidgetTicketFavorites;
